// The languages the patient form exists in — also the languages a patient can choose for our
// e-mails and messages (Step 2). Each name is written in its own language, in every locale.
export const PATIENT_LANGUAGES = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
] as const
export type PatientLanguage = typeof PATIENT_LANGUAGES[number]['code']

export function isPatientLanguage(value: unknown): value is PatientLanguage {
  return PATIENT_LANGUAGES.some(l => l.code === value)
}

/**
 * The language we write to the patient in (Submission.language → PsyCloud `language`, read by
 * Customer.io): what the patient picked in Step 2, else the language they are filling the form
 * in — the dropdown shows exactly that until they change it, so going on counts as confirming.
 * Undefined when neither is one of ours; never a guessed default.
 */
export function communicationLanguage(chosen: unknown, formLanguage: unknown): PatientLanguage | undefined {
  if (isPatientLanguage(chosen)) return chosen
  return isPatientLanguage(formLanguage) ? formLanguage : undefined
}
